export default __webpack_public_path__ + "static/media/SG-LightBlue-0001.ceef5a8a.png";